module.exports = __webpack_public_path__ + "img/xjxbg.7f210190.jpg";